import Card from "./card.js";
export default class CaptionedImage extends Card {
  constructor(t, s, i, h, e, r, a, o, c, n, d, p, u, l, m, f) {
    super(t, s, i, h, e, r, a, o, c, n, d, p, u, l, m, f),
      (this.ae = "ab-captioned-image"),
      (this.oe = !0),
      (this.test = !1);
  }
  bt() {
    const t = {};
    return (
      (t[Card.hs.ss] = Card.rs.es),
      (t[Card.hs.os] = this.id),
      (t[Card.hs.cs] = this.viewed),
      (t[Card.hs.ns] = this.title),
      (t[Card.hs.ds] = this.imageUrl),
      (t[Card.hs.ps] = this.description),
      (t[Card.hs.us] = this.updated),
      (t[Card.hs.ls] = this.expiresAt),
      (t[Card.hs.URL] = this.url),
      (t[Card.hs.fs] = this.linkText),
      (t[Card.hs.xs] = this.aspectRatio),
      (t[Card.hs.bs] = this.extras),
      (t[Card.hs.gs] = this.pinned),
      (t[Card.hs.js] = this.dismissible),
      (t[Card.hs.zs] = this.clicked),
      (t[Card.hs.ks] = this.language),
      (t[Card.hs.qs] = this.altImageText),
      (t[Card.hs.vs] = this.test),
      t
    );
  }
}
